// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f676efc8","239":"09dad67b","455":"772d59ff"}[chunkId] + ".chunk.js";
};